import { H2 } from '@liveauctioneers/hammer-ui-core/text';

import { FeaturedAuctioneer } from '@/redux/modules/home/home.types';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

import { AuctioneerCard } from './AuctioneerCard';

type FeaturedAuctioneersGridProps = {
    featuredAuctioneers: FeaturedAuctioneer[];
};

export const FeaturedAuctioneersGrid = ({ featuredAuctioneers }: FeaturedAuctioneersGridProps) => {
    const formatMessage = useAppFormatMessage();

    return (
        <div className="mx-auto flex w-full flex-col gap-sm text-center">
            <H2>{formatMessage(['featuredAuctioneers', 'featured'])}</H2>
            <div className="mx-auto grid w-full grid-cols-3 gap-sm mdMin:grid-cols-6 tabletMin:gap-md">
                {featuredAuctioneers.map(({ destinationURL, featuredAuctioneerId, houseId, houseName, imageURL }) => (
                    <AuctioneerCard
                        destinationURL={destinationURL}
                        featuredAuctioneerId={featuredAuctioneerId}
                        houseId={houseId}
                        houseName={houseName}
                        imageURL={imageURL}
                        key={`${featuredAuctioneerId}-${houseId}`}
                        shouldUseHomePageRedesign
                    />
                ))}
            </div>
        </div>
    );
};
